export default {
  header: {
    hours: "Monday-Friday : 07.00 - 17.00",
  },
  nav: {
    home: "Home",
    profile: "Profile",
    products: "Products",
    concrete: "Concrete Industry",
    mine: "Mining Industry",
    media: "Media",
    gallery: "Gallery",
    article: "Articles",
    news: "News",
    faq: "FAQ",
    contact: "Contact Us",
  },
  common: {
    article: "Article",
    news: "News",
    readMore: "Read More",
    statsYears: "Years of Experience",
    statsEmployees: "Expert Employees",
    statsProjects: "Projects Realized",
  },
  cta: {
    title: "Always moving and providing solutions for Indonesian industry",
    subtitle: "Tell us what you need, our team is ready to help.",
  },
  footer: {
    contactInfo: "Contact Information",
    address:
      "Kawasan Industri Mekar Jaya KM.7 Jl. Karet IV No. 36 - 40, Mekar Jaya, Sepatan, Kab. Tangerang, Banten 15520",
    company: "Company",
    profile: "Profile",
    concreteProducts: "Concrete Industry Products",
    mineProducts: "Mining Industry Products",
    gallery: "Gallery",
    help: "Help",
    article: "Articles",
    news: "News",
    follow: "Follow Us",
    privacy: "Privacy Policy",
    terms: "Terms & Condition",
  },
  home: {
    badgeLabel: "Welcome to",
    heroTitle: "Smart Solutions for Industrial Needs",
    heroSubtitle:
      "We work to improve productivity, effectiveness & convenience with the best innovative solutions.",
    aboutTag: "About Ligno Specialty Chemicals at a Glance",
    aboutTitle: "Indonesia's industrial chemical solutions partner since 2001",
    aboutBody:
      "<b>PT. Ligno Specialty Chemicals (LSC)</b> is an industrial chemical manufacturer in Tangerang, Banten, established in 2001, previously active for more than five years as an agent and distributor of Lignosulfonate products in Indonesia",
    knowUs: "Get to Know Us",
    whyTitle: "Why Ligno Specialty Chemicals?",
    whySubtitle: "The commitments we uphold in serving your industrial needs.",
    reasons: {
      r1: {
        title: "Competent",
        text: "LIGNO is supported by competent and passionate people in their fields",
      },
      r2: {
        title: "Guaranteed Product Quality",
        text: "LIGNO ensures product material quality is maintained through the international ISO 9001 standard",
      },
      r3: {
        title: "Fast",
        text: "LIGNO offers speed with a lean and efficient company structure.",
      },
      r4: {
        title: "Trustworthy",
        text: "LIGNO has been trusted across various industries for more than 10 years",
      },
    },
    solutionTitle1: "Providing Solutions",
    solutionTitle2: "For Every Need",
    solutionBody:
      "More than just a product provider, Ligno is a solutions partner that helps customers face every challenge through reliable service, quality products, and a results-oriented approach.",
    seeActivities: "See Our Activities",
    locationTitle: "Our Location",
    locationHours: "Monday - Friday, 07.00 - 17.00",
    openMap: "Open Map",
    testimonyTitle: "What They Say About Ligno Specialty Chemicals",
    testimonySubtitle: "Their experience working with LIGNO.",
    articlesTitle: "Always Moving and Providing Solutions",
  },
  profile: {
    introTitle1: "We are here to",
    introTitleEm: "deliver the best solutions and products",
    introTitle2: "to meet the needs of Indonesian industry",
    aboutP1:
      "<b>PT. Ligno Specialty Chemicals (LSC)</b> is an industrial chemical manufacturer in Tangerang, Banten, established in 2001, previously active for more than five years as an agent and distributor of Lignosulfonate products in Indonesia",
    aboutP2:
      "Since its founding, PT. Ligno Specialty Chemicals has continuously developed superior products that compete on quality at competitive prices. We uphold professionalism, always strive to provide innovative solutions, work in a spirit of togetherness, and always show respect for the environment.",
    valuesTitle: "Ligno Specialty Chemicals Upholds Its Core Values",
    values: {
      v1: {
        title: "Competent",
        text: "LIGNO is supported by competent and passionate people in their fields",
      },
      v2: {
        title: "Guaranteed Product Quality",
        text: "LIGNO ensures product material quality is maintained through the international ISO 9001 standard",
      },
      v3: {
        title: "Fast",
        text: "LIGNO offers speed with a lean and efficient company structure.",
      },
      v4: {
        title: "Trustworthy",
        text: "LIGNO has been trusted across various industries for more than 20 years",
      },
    },
    historyTitle: "A Brief History of PT Ligno Specialty Chemicals",
    historyAria: "History periods",
    period: "Period",
    history: {
      h0: {
        t1: "Beginning",
        d1: "LSC served as the representative of the world's largest lignosulfonate producer",
        t2: "Incorporation",
        d2: "LSC was legally incorporated and became the distributor for 2 of the world's largest lignosulfonate producers",
      },
      h1: {
        t1: "First Production",
        d1: "LSC began independent production and development under the LIGNO brand, with Indonesia's largest carbon black producer as its first customer",
        t2: "First Factory",
        d2: "Built the first factory in Tangerang",
      },
      h2: {
        t1: "Concrete Laboratory",
        d1: "Factory expansion and establishment of a concrete laboratory",
        t2: "Chemical Laboratory",
        d2: "Factory expansion, construction of a new laboratory, and expansion into the fertilizer industry",
      },
      h3: {
        t1: "Representatives",
        d1: "Placed sales representatives in Surabaya and Padang",
        t2: "Partnerships",
        d2: "Trusted by various state-owned enterprises across sectors and established research collaborations with universities",
      },
      h4: {
        t1: "Modern Laboratory",
        d1: "Factory expansion and construction of a modern chemical laboratory",
        t2: "Research Collaboration",
        d2: "Established research collaborations with state-owned enterprises",
      },
    },
    visiTitle: "Vision of PT Ligno Specialty Chemicals",
    visiText:
      "To become the best chemical manufacturing company capable of competing globally",
    misiTitle: "Mission of PT Ligno Specialty Chemicals",
    misiText:
      "To produce superior, environmentally friendly chemical products while prioritizing customer satisfaction.",
  },
  faq: {
    titleEm: "Frequently",
    titleRest: " Asked Question",
    subtitle:
      "Find answers to frequently asked questions about Ligno Specialty Chemicals",
  },
  article: {
    titleEm: "Ligno",
    titleRest: " Articles",
    subtitle:
      "Keep up with the industrial world through tips, success stories, and the latest product updates from Ligno Specialty Chemicals.",
    searchPlaceholder: "Search Articles",
  },
  news: {
    titleEm: "Ligno",
    titleRest: " News",
    subtitle: "Follow the latest activities of Ligno Specialty Chemicals",
    searchPlaceholder: "Search News",
  },
  gallery: {
    titleEm: "Ligno",
    titleRest: " Gallery",
    subtitle:
      "Documentation of activities and facilities of Ligno Specialty Chemicals",
  },
  detail: {
    backToArticles: "Back to All Articles",
    backToNews: "Back to All News",
    readOtherArticles: "Read More Articles",
    readOtherNews: "Read More News",
    readOthersDefault: "Read More Articles & News",
  },
};
